import { koComponent } from '../ko-utils';
import { SegmentModel } from '../models/Gen/BaseModels';

class SegmentationSelector {
    /**
     * Params:
     *  - segments
     *  - rules
     *  - segmentId
     * 
     * @param {any} params
     */
    constructor(params) {

        this.segments = ko.observableArray();
        this.segmentationSelected = ko.observable();
        this.rules = params.$raw.rules();
        this.segmentId = params.segmentId;
        this.allTours = params.allTours;
        this.allSegments = params.segments;

        for (const segment of ko.unwrap(params.segments)) {
            this.segments.push(new SegmentModel(segment));
        }
        this.segmentationSelected((() => {
            const hasSegment = !!ko.unwrap(params.segmentId);

            const rulesObj = ko.unwrap(params.rules);
            const hasRules = rulesObj && !!ko.unwrap(rulesObj.rules) && rulesObj.rules().length > 0;

            if (!hasRules && !hasSegment) return 'all';
            if (hasSegment) return 'segment';
            if (hasRules) return 'rules';
        })());
        this.segmentationSelected.subscribe((val) => {
            if (val == 'all') {
                params.segmentId(null);

                const rulesObj = params.rules();
                if (rulesObj && rulesObj.rules && rulesObj.rules.removeAll) {
                    rulesObj.rules.removeAll();
                }
            } else if (val == 'segment') {
                const rulesObj = params.rules();
                if (rulesObj && rulesObj.rules && rulesObj.rules.removeAll) {
                    rulesObj.rules.removeAll();
                }
            } else if (val == 'rules') {
                params.segmentId(null);
            }
        });
    }
}

export default koComponent('segmentation-selector', SegmentationSelector);